import { Routes } from "@angular/router";
import { AttestationsComponent } from "./attestations/attestations.component";
import { ErrorComponent } from "./components/error/error.component";
import { CompromiseReportsComponent } from "./compromise-reports/compromise-reports.component";
import { HomeComponent } from "./home/home.component";
import { SecurityPoliciesComponent } from "./security-policies/security-policies.component";
import { MenuSettingsComponent } from "./settings/menu-settings/menu-settings.component";
import { canActivateAuthRole } from "src/app/guards/auth-role.guard";

export const routes: Routes = [
  { path: "", component: HomeComponent },
  {
    path: "compromise-reports",
    component: CompromiseReportsComponent,
    canActivate: [canActivateAuthRole],
    data: { role: "bo-dip-policy-violations-viewer" }
  },
  {
    path: "attestations",
    component: AttestationsComponent,
    canActivate: [canActivateAuthRole],
    // data: { role: ["bo-dip-attestations-viewer", "bo-dip-browser-attestations-viewer"], env: "develop" }
    data : { role : "bo-dip-attestations-viewer" }
  },
  {
    path: "settings",
    component: MenuSettingsComponent,
    canActivate: [canActivateAuthRole],
    data: { role: "bo-dip-wl-admin" }
  },
  {
    path: "security-policies",
    component: SecurityPoliciesComponent,
    canActivate: [canActivateAuthRole],
    data: { role: "bo-dip-security-policies-viewer", env: "develop" }
  },
  {
    path: "error",
    component: ErrorComponent
  },
  { path: "**", redirectTo: '/error' }
];
